"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_1 = require("react-router");
var common_1 = require("stremio/common");
var routerPaths_1 = __importDefault(require("./routerPaths"));
var Route_1 = __importDefault(require("./Route"));
var VIEW_COUNT = Math.max.apply(Math, routerPaths_1.default.map(function (route) { return route.view; })) + 1;
var getRouteForLocation = function (location) {
    return routerPaths_1.default.find(function (route) { return (0, react_router_1.matchPath)({ path: route.path, end: true }, location.pathname); });
};
var getNextViews = function (currentViews, location) {
    var route = getRouteForLocation(location);
    if (!route) {
        return currentViews;
    }
    return Array.from({ length: VIEW_COUNT }, function (_, index) {
        if (index < route.view) {
            return currentViews[index] || null;
        }
        if (index === route.view) {
            return {
                key: "".concat(route.view, ":").concat(route.path),
                location: location,
                route: route,
            };
        }
        return null;
    });
};
var Routes = function () {
    var location = (0, react_router_1.useLocation)();
    var navigate = (0, react_router_1.useNavigate)();
    var profile = (0, common_1.useProfile)();
    var previousAuthRef = react_1.default.useRef(profile.auth);
    var _a = react_1.default.useState(function () { return getNextViews([], location); }), views = _a[0], setViews = _a[1];
    /**
     * Replaced onRouteChange with following useEffect:
     */
    react_1.default.useEffect(function () {
        // Handle redirect if user logs out
        if (previousAuthRef.current !== null && profile.auth === null) {
            previousAuthRef.current = profile.auth;
            navigate('/intro', { replace: true });
        }
        // Handle redirect if user is logged in on intro screen
        if (profile.auth !== null && location.pathname === '/intro') {
            navigate('/', { replace: true });
        }
        previousAuthRef.current = profile.auth;
    }, [location.pathname, profile.auth]);
    react_1.default.useLayoutEffect(function () {
        setViews(function (currentViews) { return getNextViews(currentViews, location); });
    }, [location]);
    var visibleViews = views.filter(function (view) { return view !== null; });
    return (react_1.default.createElement("div", { className: 'routes-container' }, visibleViews.map(function (view, index) { return (react_1.default.createElement(react_router_1.Routes, { key: view.key, location: view.location },
        react_1.default.createElement(react_router_1.Route, { path: view.route.path, element: react_1.default.createElement(Route_1.default, { component: view.route.element, focused: index === visibleViews.length - 1 }) }))); })));
};
exports.default = Routes;
